<template>
    <div
        @click="$emit('click')"
        class="betslip__ticket-preview"
    >
        <i class="icon icon-ticket" />
    </div>
</template>

<script>
    export default {
        name: 'TicketPreviewButton',
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/TicketPreviewButton.vue